import { C } from '../theme'
import { useContent } from '../content/ContentContext'
import { mediaAlt, mediaUrl } from '../content/derive'

export function Hero() {
  const { home, settings } = useContent()
  const hero = home.hero ?? {}
  const emblemUrl = mediaUrl(settings.branding?.emblem)
  const heroImage = mediaUrl(hero.image)

  return (
    <section id="top" className="sec" style={{ position: 'relative', minHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
        {heroImage && (
          <img
            src={heroImage}
            alt={mediaAlt(hero.image, hero.imageAlt)}
            style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
          />
        )}
        <div
          style={{
            position: 'absolute', inset: 0,
            background:
              'linear-gradient(180deg, rgba(27,79,156,.46) 0%, rgba(250,246,239,.30) 52%, rgba(250,246,239,.92) 84%, #faf6ef 100%)',
          }}
        />
      </div>
      <div
        style={{
          position: 'relative', flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', textAlign: 'center', padding: '84px 40px 64px', maxWidth: 900,
          margin: '0 auto', animation: 'cddFade .9s ease both',
        }}
      >
        {emblemUrl && (
          <img
            src={emblemUrl}
            alt=""
            style={{ height: 118, width: 'auto', marginBottom: 24, filter: 'drop-shadow(0 10px 24px rgba(0,0,0,.22))', animation: 'cddFloat 6s ease-in-out infinite' }}
          />
        )}
        <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase', color: C.red, marginBottom: 22, textShadow: '0 1px 10px rgba(250,246,239,.7)' }}>
          {hero.eyebrow}
        </div>
        <h1 className="hero-title" style={{ fontFamily: "'Spectral',serif", fontWeight: 400, fontSize: 66, lineHeight: 1.04, margin: '0 0 18px', color: C.ink, letterSpacing: '-.015em', textWrap: 'balance', textShadow: '0 2px 20px rgba(250,246,239,.5)' }}>
          {hero.title}
        </h1>
        <div style={{ fontFamily: "'Spectral',serif", fontStyle: 'italic', fontWeight: 400, fontSize: 21, color: C.blue, maxWidth: 600, lineHeight: 1.5, marginBottom: 22 }}>
          {hero.verse}
        </div>
        <p style={{ fontSize: 18, lineHeight: 1.6, color: C.body, maxWidth: 560, margin: '0 0 32px', fontWeight: 500 }}>
          {hero.intro}
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap', justifyContent: 'center' }}>
          {hero.primaryCtaLabel && (
            <a className="btn" href="#eventos" style={{ background: C.red, color: '#fff', fontWeight: 700, fontSize: 15, padding: '16px 32px', borderRadius: 3, textDecoration: 'none', boxShadow: '0 8px 24px rgba(193,39,45,.32)' }}>
              {hero.primaryCtaLabel}
            </a>
          )}
          {hero.secondaryCtaLabel && (
            <a className="btn" href="#ayuda" style={{ background: '#fff', color: C.blue, fontWeight: 700, fontSize: 15, padding: '16px 30px', borderRadius: 3, textDecoration: 'none', border: `1.5px solid ${C.blue}` }}>
              {hero.secondaryCtaLabel}
            </a>
          )}
        </div>
      </div>
    </section>
  )
}
